import { toObservable } from "@angular/core/rxjs-interop";
import { signal } from "@angular/core";
import { addYears } from "date-fns";
import { PeriodType } from "@bitwarden/web-vault/app/models/types/filter.types";
import { BalanceDatesUtils } from "@bitwarden/web-vault/app/services/store/calculation-base/balances/balanceDates.utils";
import { PeriodSelectionController } from "@bitwarden/web-vault/app/services/store/calculation-base/controls/period.control";

export class ScenarioPeriodController extends PeriodSelectionController {
  protected _selected = signal<PeriodType>(this.getDefaultSelection());
  selected = this._selected.asReadonly();

  /** **<span style="color: red;">This is for store use only</span>** **/
  readonly selected$ = toObservable(this.selected);

  clear() {
    this._selected.set(this.getDefaultSelection());
  }

  /**
   * Update range selection, set _isDefault to false automatically to flag human action
   */
  updateSelection(period: PeriodType) {
    const adjustedPeriod = {
      startDate: BalanceDatesUtils.getStartOfDayDate(period.startDate),
      endDate: BalanceDatesUtils.getEndOfDayDate(period.endDate),
      _isDefault: false,
    };
    this._selected.set(adjustedPeriod);
  }

  /**
   * The default SELECTED range: a today-to-+1-year window. Recomputes "today" from the current
   * wall clock on every call, so a reset/clear in a long-lived session lands on today's window
   * instead of whenever the controller was constructed. Normalized to day granularity (like the
   * other period controllers), so repeated calls within the same day return equal values (new
   * objects each time, so callers compare or cache by value).
   */
  getDefaultSelection(): PeriodType {
    const today = BalanceDatesUtils.getStartOfDayDate(new Date());
    return {
      startDate: today,
      endDate: BalanceDatesUtils.getEndOfDayDate(addYears(today, 1)),
      _isDefault: true,
    };
  }
}
